import { convertTimeTo12Hr } from 'utils/bolt/showtimes';
import formatDateTime from 'utils/formatDateTime';

export const getScreeningDetailsFormatted = ({ date, time, format }, clockFormat) => {
	const dateParts = date.split('-');
	let screeningDate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
	screeningDate = formatDateTime(screeningDate, 'ddd dd MMM');
	if ((clockFormat || '24') === '12') {
		time = convertTimeTo12Hr(time);
	}

	return {
		date: screeningDate,
		time,
		format: format || '2D'
	};
};